import React, { useCallback, useContext } from 'react';
import { MonthPicker } from '@components/pickers/month-picker';
import { CalendarContext } from '../../calendar-context';
import { getScaleLabel } from '../../utils';

export function CalendarMonthPicker() {
  const { currentDate, setCurrentDate, settings, dataSource } =
    useContext(CalendarContext);

  const handleChange = useCallback(
    (value: number) => {
      setCurrentDate(value);
      dataSource.yAxis.refreshData();
    },
    [dataSource.yAxis, setCurrentDate]
  );

  return (
    <MonthPicker
      labelMapper={(d) => getScaleLabel(d, settings, [])}
      currentDate={currentDate}
      onChange={handleChange}
    />
  );
}
